import DealItem from './DealItem';

const dealConfig = {
  Outlet: {
    type: "Outlet",
    label: "Outlet",
    title: "Bättre blir det inte",
    text: "Kolla in denna Outlet-bil med sänkt pris och attraktiv ränta. Det är vad vi kallar en enkel väg till en bra deal.",
    buttons: [
      { href: "/bilar-i-lager/?activeDeals=outlet", text: "Se fler outlet-bilar" },
      { href: "/begagnat/outlet/", text: "Läs mer", className: "outline" }
    ]
  },
  Superdeal: {
    type: "Superdeal",
    label: "Superdeal",
    title: "Utmärkt fynd-läge",
    text: "Denna bil har just fått ett riktigt bra pris, så nu har du en ypperlig chans att göra en riktigt bra affär. Köp den nu, innan någon annan hinner före.",
    buttons: [
      { href: "/bilar-i-lager/?activeDeals=superdeal", text: "Se fler superdeals" }
    ]
  },
  Demo: {
    type: "Demo",
    label: "Demobil",
    title: "Betala mindre för nybilskänslan",
    text: "Nu finns det möjlighet att förhandsköpa denna exklusiva demobil. Med perfekt skick och få mil på mätaren erbjuder den dig det bästa av två världar - nybilskänsla och ett pris som gläder plånboken. Passa på, innan någon annan hinner före.",
    buttons: [
      { href: "/bilar-i-lager/?activeDeals=demo", text: "Se fler demobilar" },
      { href: "/bilar/demobilar/", text: "Läs om fördelar", className: "outline" }
    ]
  }
};

const DealsSection = ({carDeals}) => {
  return (
      carDeals &&
      <div className="section deals">
        {carDeals.map((dealType) => {
          const deal = dealConfig[dealType];
          return deal ? (
              <DealItem
                  key={deal.type}
                  type={deal.type}
                  label={deal.label}
                  title={deal.title}
                  text={deal.text}
                  buttons={deal.buttons}
              />
          ) : null;
        })}
      </div>
  );
};

export default DealsSection;